<template>
  <div class="error-layout">
    <div class="text">
      <slot />
    </div>
    <div class="logo">
      <img :src="`${publicPath}img/logo.png`" alt="logo-nkr-motors-group" />
    </div>
    <div>
      <h2>
        <router-link to="/">{{ $t("message.go_back_to_home") }}</router-link>
      </h2>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.error-layout {
  width: 100%;
  height: 100%;
  color: $text-clear-3;
  background-color: $background-main;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  div {
    margin: 30px 0px;
  }
  .text {
    color: $text-clear-3;
    text-shadow: $text-clear-3-shadow;
  }
}
a {
  color: $text-clear-3 !important;
  text-shadow: $text-clear-3-shadow;
}
.logo {
  width: 100%;
  max-width: 300px;
  img {
    width: 100%;
  }
}
</style>
